import { API, graphqlOperation } from "aws-amplify";
import { updateInventorie, updateInventorieMini } from "./custom-mutations";

// performDeleteAccount - call graphQl, no try-catch
// handleCreateAccount - with try-catch
// processUpdateAccount - process for lambda

export const sanitizeInventoryLambda = ({
  account,
  area,
  inboundShipment,
  inventoryItems,
  location,
  outboundShipment,
  photos,
  product,
  reloadYardCommodity,
  shipmentLineItems,
  zone,
  // legacy fields
  locationFullName,
  locationId,
  ...rest
}) => rest;

export const sanitizeInventory = (inventory) => {
  const sanitized = sanitizeInventoryLambda(inventory);
  const { createdAt, updatedAt, ...rest } = sanitized;
  return rest;
};

// custom-mutations.updateInventorie
export const performUpdateInventory = async (inventory) => {
  const inventoryInput = sanitizeInventory(inventory);
  return API.graphql(
    graphqlOperation(updateInventorie, { input: inventoryInput }),
  );
};

// custom-mutations.updateInventorieMini
export const performUpdateInventoryMini = async (inventory) => {
  const inventoryInput = sanitizeInventory(inventory);
  return API.graphql(
    graphqlOperation(updateInventorieMini, { input: inventoryInput }),
  );
};

export const sanitizeInventoryItem = (inventoryItem) => {
  const sanitized = { ...inventoryItem };
  [
    // "aisle",
    "area",
    "barcodes",
    "createdAt",
    "inventory",
    "location",
    "seals",
    "updatedAt",
    "zone",
  ].forEach((key) => delete sanitized[key]);
  return sanitized;
};
